export const replaceAuthUrlToHome = () => {
	if (typeof window === 'undefined') return;
	window.history.replaceState(null, '', '/');
};
